import { AppBar, IconButton, Toolbar, Typography, Box, Avatar } from "@mui/material";
import Settings from "../Components/Settings";
import { LayoutProps } from "../Types/LayoutType";
import MenuIcon from '@mui/icons-material/Menu';
import BusinessIcon from '@mui/icons-material/Business'; // Import dummy icon
import { useQuery } from "@apollo/client";
import { GET_ORG_BY_ID } from "../Graphql/Queries"; // Import the query to get organization by ID
import { useSelector } from "react-redux"; // Import Redux hook to access user details

const Header = ({ drawerWidth, mobileOpenBool, setMobileToggle, collapsed }: LayoutProps & { collapsed: boolean }) => {
  // Get organization ID and user details from Redux state
  const { organization: orgId, name } = useSelector((state: any) => state.auth);

  // Skip query if orgId is not available
  const { data, loading, error } = useQuery(GET_ORG_BY_ID, {
    variables: { organizationByIdId: orgId },
    skip: !orgId,
  });

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error fetching organization data</p>;

  const organizationName = data?.organizationById?.name; 
  const organizationImage = data?.organizationById?.image; 

  return (
    <AppBar
      position="fixed"
      sx={{
        width: { sm: `calc(100% - ${collapsed ? 64 : drawerWidth}px)` }, 
        ml: { sm: `${collapsed ? 64 : drawerWidth}px` }, 
        background: 'linear-gradient(123.76deg, #F2709C 9.95%, #FF9472 86.42%)',
      }}
    >
      <Toolbar sx={{ height: '80px' }}> {/* Adjust the height of the Toolbar */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="start"
          onClick={() => setMobileToggle(!mobileOpenBool)}
          sx={{ mr: 2, display: { sm: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Organization Image or Nothing */}
          {orgId && (
            organizationImage ? (
              <Avatar
                src={organizationImage}
                alt={organizationName || "Organization"}
                sx={{ width: 40, height: 40 }}
              />
            ) : (
              <BusinessIcon sx={{ fontSize: 40, color: '#ffffff' }} />
            )
          )}
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
            <Typography variant="subtitle1" noWrap component="div" sx={{ color: '#ffffff' }}>
              {orgId ? `Welcome ${name}` : 'Welcome'}
            </Typography>
            <Typography variant="subtitle1" noWrap component="div" sx={{ color: '#ffffff', fontWeight: 'bold', fontSize: '19px' }}>
              {orgId ? organizationName : name}
            </Typography>
          </Box>
        </Box>
        {/* Push Settings to the right */}
        <Box sx={{ marginLeft: 'auto' }}>
          <Settings />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
